import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ChallengeError } from '@backbase/identity-core-ang';
import { ChallengeHardTokenData, HardTokenResponse } from './hard-token.model';

@Component({
  selector: 'bb-transaction-signing-hard-token',
  templateUrl: 'hard-token.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionSigningHardTokenComponent {
  @Output() cancel = new EventEmitter<void>();
  /* tslint:disable-next-line */
  @Output() complete = new EventEmitter<HardTokenResponse>();
  @Output() acceptError = new EventEmitter<Error>();

  @Input()
  set data(value: ChallengeHardTokenData) {
    this.challengeData = value;
    this.displayAlert = false;
    this.displayErrors = false;
  }

  get data() {
    if (!this.challengeData) {
      throw new Error('No challenge data set');
    }
    return this.challengeData;
  }

  @Input()
  set error(value: ChallengeError | undefined) {
    this.displayAlert = false;
    this.displayErrors = false;
    if (value && this.isRecognizedError(value)) {
      this.displayAlert = true;
    } else {
      this.errorValue = value;
    }
  }

  get error() {
    return this.errorValue;
  }

  private readonly invalidRequestError = 'invalid_request';
  private displayErrors = false;
  readonly form: FormGroup = this.formBuilder.group({
    otp: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
  });
  errorValue: ChallengeError | undefined;
  challengeData: ChallengeHardTokenData | undefined;
  displayAlert = false;

  constructor(private readonly formBuilder: FormBuilder) {}

  onComplete() {
    this.displayErrors = true;
    if (this.form.valid) {
      this.complete.emit({
        ...this.form.value,
        code: this.data.data.code,
      } as HardTokenResponse);
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  onErrorClose(error: Error) {
    this.acceptError.emit(error);
  }

  hasError(control: AbstractControl) {
    return this.displayErrors && control.errors && (control.errors.required || control.errors.pattern);
  }

  getTransactionAmount() {
    return Number(this.data.data.txnData.paymentAmount).toFixed(2);
  }

  private isRecognizedError(error: ChallengeError) {
    return error.errorCode === this.invalidRequestError && error.errorDescription === this.invalidRequestError;
  }
}
